import { ChannelEnum } from "@c2b/muven-commons";

export class ChannelCreationModel {
	readonly fromChannel: number = 1;
	readonly defaultProductStoreChannelActive: number = 0;
	confirmationMessage: string = '';
	channel: {
		name: string;
		enumChannel: ChannelEnum;
	};

	isValid(): boolean {
		return !!this.fromChannel != undefined &&
		       !!this.defaultProductStoreChannelActive != undefined &&
		       (this.confirmationMessage?.toUpperCase()?.trim() === 'CONFIRMO') &&
		       !!this.channel?.name && 
		       (this.channel?.enumChannel != null);
	}
}
